export const isPermission = (prm) => {
  const pxm = localStorage.getItem('pxm')
  // console.log(typeof (pxm)) //string
  if (pxm && pxm !== 'null') {
    const status = JSON.parse(pxm).find((item) => { return item.permission_name === prm })
    return !!status
  } else {
    return false
  }
}
